import React, {useCallback} from 'react';
import {FormFieldOption} from '@src/@types/components/Form';
import ErrorRepresentation from '@src/components/ErrorRepresentation/ErrorRepresentation';
import Translate from '@src/components/Translate/Translate';
import useUniqueId from '@src/hooks/useUniqueId';
import CustomSelect from '@src/components/Fields/CustomSelect';
import useConfigValue from '@src/hooks/useConfigValue';
import config from '@src/helpers/config';
import {notNull} from '@src/helpers/ts/notNull';

const wrapperStyles = {maxWidth: '600px'} as React.CSSProperties;

export default function OrdersListenOnlyTheseStatusesSoundSetting(props: {
    notificationName: string,
    options?: FormFieldOption[],
    error?: Error | null,
    isLoading: boolean,
    className?: string,
}) {
    const id = useUniqueId();
    const label = `SoundsSettings.notifications.${props.notificationName}.play-when-its-has-one-of-these-statuses`;
    const name = `settings.notifications.${props.notificationName}.statuses` as any;
    const value = useConfigValue<number[]>(name, []);
    const onChange = useCallback((ids?: (string | number | null)[]) => {
        config().set(name, (ids ?? []).filter(notNull));
    }, [name]);

    if (props.error) {
        return <ErrorRepresentation
                error={props.error}
                outsideContainer
                className="mb-0"
        />;
    }

    return <div style={wrapperStyles} className={props.className}>
        <Translate<HTMLLabelElement>
                message={label}
                tag="label"
                htmlFor={id}
        />
        <CustomSelect<true>
                inputId={id}
                label={label}
                options={props.options}
                onChange={onChange}
                value={value}
                isLoading={props.isLoading}
                clearable
                multiple
        />
    </div>;
}
